var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "51px",
    viewBox: "0 0 300 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "#09415b",
    strokeWidth: 2,
    fill: "#09415b",
    fillRule: "nonzero",
    points: "28 4 33.848739 21.1238938 52 21.1238938 37.478992 31.8761062 42.722689 49 28 38.8451327 13.277311 49 18.521008 31.8761062 4 21.1238938 22.151261 21.1238938"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#09415b",
    strokeWidth: 2,
    fill: "#09415b",
    fillRule: "nonzero",
    points: "89 4 94.848739 21.1238938 113 21.1238938 98.478992 31.8761062 103.722689 49 89 38.8451327 74.277311 49 79.521008 31.8761062 65 21.1238938 83.151261 21.1238938"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#09415b",
    strokeWidth: 2,
    fill: "#09415b",
    fillRule: "nonzero",
    points: "150 4 155.848739 21.1238938 174 21.1238938 159.478992 31.8761062 164.722689 49 150 38.8451327 135.277311 49 140.521008 31.8761062 126 21.1238938 144.151261 21.1238938"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#09415b",
    strokeWidth: 2,
    fill: "#09415b",
    fillRule: "nonzero",
    points: "211 4 216.848739 21.1238938 235 21.1238938 220.478992 31.8761062 225.722689 49 211 38.8451327 196.277311 49 201.521008 31.8761062 187 21.1238938 205.151261 21.1238938"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#09415b",
    strokeWidth: 2,
    fill: "#09415b",
    fillRule: "nonzero",
    points: "272 4 277.848739 21.1238938 296 21.1238938 281.478992 31.8761062 286.722689 49 272 38.8451327 257.277311 49 262.521008 31.8761062 248 21.1238938 266.151261 21.1238938"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.eb89fce99384e3599157a7b45f8b1bcb.svg";
export { ForwardRef as ReactComponent };